import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
// import { TextField, Button } from "@mui/material";
import InputComponent from "../components/InputComponent";
// import QRCode from 'qrcode.react';

import Pattern from "../assets/images/pattern.png";
import LoginBg1 from "../assets/images/login-02.png";
import Logo from "../assets/images/new_vitalX_logo.svg";
import { register, sendOtp, verifyOtp } from "../services/authApi";
import VisibilityIcon from "@mui/icons-material/Visibility";

import { showToast } from "../utils/toastUtils";
import { ToastContainer } from "react-toastify";
import CustomSelect from "../components/CustomSelect";
import { Role } from "../utils/commonData";

import {
  otpValidationSchema,
  phoneValidationSchema,
  registractionValidation,
  registractionValidationReceptionist,
} from "../utils/validations/registrationValidation";
import { Formik, Form, useFormik } from "formik";

const Registration = (doctor) => {
  const initialWorkingDays = {
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
    sunday: false,
  };

  const navigate = useNavigate();
  const [role, setRole] = useState("doctor");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [step, setStep] = useState(1);
  const [workingDays, setWorkingDays] = useState(initialWorkingDays);
  const [errorMessage, setErrorMessage] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const defaultWorkingHours = {
    monday: [
      { start: "09:00", end: "12:00", enabled: true },
      { start: "17:00", end: "19:00", enabled: true },
    ],
    tuesday: [
      { start: "09:00", end: "12:00", enabled: true },
      { start: "17:00", end: "19:00", enabled: true },
    ],
    wednesday: [
      { start: "09:00", end: "12:00", enabled: true },
      { start: "17:00", end: "19:00", enabled: true },
    ],
    thursday: [
      { start: "09:00", end: "12:00", enabled: true },
      { start: "17:00", end: "19:00", enabled: true },
    ],
    friday: [
      { start: "09:00", end: "12:00", enabled: true },
      { start: "17:00", end: "19:00", enabled: true },
    ],
    saturday: [
      { start: "09:00", end: "12:00", enabled: true },
      { start: "17:00", end: "19:00", enabled: true },
    ],
    sunday: [
      { start: "09:00", end: "12:00", enabled: true },
      { start: "17:00", end: "19:00", enabled: true },
    ],
  };

  const [workingHours, setWorkingHours] = useState(defaultWorkingHours);

  const phoneFormik = useFormik({
    initialValues: {
      phoneNumber: "",
    },
    validationSchema: phoneValidationSchema,
    onSubmit: async (values) => {
      const { status, message } = await sendOtp(values.phoneNumber);
      setPhoneNumber(values.phoneNumber);
      if (status) {
        showToast("OTP send");
        setErrorMessage(null);
        setTimeout(() => {
          setStep(2);
        }, 1000);
      } else {
        console.error("Failed to send OTP:", message);
        alert(message);
      }
    },
  });

  const otpFormik = useFormik({
    initialValues: {
      otp: "",
    },
    validationSchema: otpValidationSchema,
    onSubmit: async (values) => {
      console.log(values, "otpFormik");
      const { success, message, data } = await verifyOtp(
        values.phoneNumber,
        values.otp
      );
      if (success) {
        console.log("Verification success:", data);
        showToast("Verification success", "success");
        setErrorMessage(null);
        setTimeout(() => {
          setIsOtpVerified(true);
          setStep(3);
        }, 1000);
      } else {
        console.error("Verification failed:", message);
        setIsOtpVerified(false);
        setErrorMessage(message);
      }
    },
  });

  const getValidationSchema = () => {
    let validationSchema;
    if (role === "doctor") {
      validationSchema = registractionValidation;
    } else if (role === "receptionist") {
      validationSchema = registractionValidationReceptionist;
    } else {
      validationSchema = registractionValidationReceptionist;
    }
    return validationSchema;
  };

  const registrationFormik = useFormik({
    initialValues: {
      email: "",
      password: "",
      confirmPassword: "",
      firstName: "",
      lastName: "",
      clinicName: "",
      experience: "",
      speciality: "",
      qualification: "",
      consultationFee: "",
    },

    validationSchema: getValidationSchema(),
    validateOnChange: false,

    onSubmit: async (values) => {
      console.log(values, "values 150");

      const wdays = Object.entries(workingDays)
        .filter(([_, value]) => value)
        .map(([key, _]) => key);
      const dayBasedWorkingHours = wdays.reduce((acc, day) => {
        acc[day] = workingHours[day]
          ? workingHours[day].map((slot) =>
              slot.enabled ? slot : { ...slot, start: "", end: "" }
            )
          : [];
        return acc;
      }, {});

      const registrationData = {
        email: values.email,
        password: values.password,
        confirmPassword: values.confirmPassword,
        role: role,
        first_name: values.firstName,
        last_name: values.lastName,
        clinic_name: values.clinicName,
        phone_number: phoneNumber,
        isMobileOTPAuthenticated: true,
        experience: values.experience,
        speciality: values.speciality,
        working_days: workingDays,
        working_hours: dayBasedWorkingHours,
        consultationFee: values.consultationFee,
        qualification: values.qualification,
      };

      console.log(registrationData);

      const { success, message } = await register(registrationData);
      if (success) {
        showToast("Registration successful:", "success");
        setTimeout(() => {
          navigate("/clinic/dashboard");
        }, 1000);
      } else {
        showToast(message, "error");
        setTimeout(() => {
          navigate("/clinic/login");
        }, 1000);
      }
    },
  });

  const handleWorkingHoursChange = (day, index, field, value) => {
    const updatedHours = [...workingHours[day]];

    if (field === "enabled" && !value) {
      const otherIndex = index === 0 ? 1 : 0;
      if (!updatedHours[otherIndex].enabled) {
        showToast("At least one time slot must be selected", "error");
        return;
      }
    }

    updatedHours[index] = { ...updatedHours[index], [field]: value };

    if (updatedHours[index].enabled) {
      if (
        field == "start" &&
        updatedHours[index].end < updatedHours[index].start
      ) {
        showToast("Start time should be before end time", "error");
        return;
      }
      if (
        field == "end" &&
        updatedHours[index].end < updatedHours[index].start
      ) {
        showToast("End time should be after start time", "error");
        return;
      }
      if (
        updatedHours[0] &&
        updatedHours[1] &&
        updatedHours[0].enabled &&
        updatedHours[1].enabled &&
        updatedHours[0].end > updatedHours[1].start
      ) {
        showToast(
          "Morning and evening time intervals should not overlap",
          "error"
        );
        return;
      }
    }
    setWorkingHours({
      ...workingHours,
      [day]: updatedHours,
    });
  };

  return (
    <div className="app-layout-blank flex flex-auto flex-col max-h-auto">
      <div className="flex w-full min-h-screen">
        <div className="bg-no-repeat bg-cover py-6 px-16 flex-col justify-between hidden lg:flex  relative overflow-hidden bg-gradient-to-t from-[#2E37A4] from-5% via-[#81BBF5] via-30% to-white to-80% w-full xl:w-5/12 drop-shadow">
          <img src={Pattern} className=" absolute  z-0 left-0" alt="" />
          <img src={LoginBg1} className=" absolute  z-0 left-0" alt="" />
          <div className=" relative overflow-hidden">
            <img src={Logo} className=" w-4/12" alt="" />
          </div>

          <div>
            <p className="text-lg text-white opacity-80">
              Transform your clinic with digital efficiency in under 30 minutes.
            </p>
          </div>
        </div>

        <div className="flex flex-col  lg:justify-center  items-center w-full  xl:w-7/12 bg-[#F5F5F6] pt-5 xl:pt-0">
          <div className="xl:w-7/12 px-5">
            <div
              className={` ${
                step === 3
                  ? ""
                  : "bg-white  px-8 md:px-10 xl:px-14 py-12  rounded-2xl"
              }`}
            >
              {step === 3 ? (
                ""
              ) : (
                <div className="mb-8">
                  <h3 className="mb-1 text-xl font-bold">Sign Up</h3>
                  <p className="text-gray-600">
                    And lets get started with your free trial
                  </p>
                </div>
              )}

              <div style={{ padding: "0" }}>
                {step === 1 && (
                  <>
                    <Formik
                      initialValues={phoneFormik.initialValues}
                      validationSchema={phoneValidationSchema}
                      onSubmit={phoneFormik.handleSubmit}
                    >
                      {({ errors, touched }) => (
                        <Form>
                          <InputComponent
                            label="Phone Number"
                            id="phoneNumber"
                            name="phoneNumber"
                            className="mb-5 w-full"
                            value={phoneFormik.values.phoneNumber}
                            onChange={phoneFormik.handleChange}
                            error={phoneFormik.errors.phoneNumber}
                          />

                          <button
                            type="submit"
                            onClick={phoneFormik.handleSubmit}
                            className="min-w-[131px] w-full text-base font-medium rounded-lg py-2 px-5  bg-[#2E37A4] hover:bg-[#1A238F] text-white"
                          >
                            Send OTP
                          </button>
                        </Form>
                      )}
                    </Formik>
                  </>
                )}
                {step === 2 && (
                  <>
                    <Formik
                      initialValues={otpFormik.initialValues}
                      validationSchema={otpValidationSchema}
                      onSubmit={otpFormik.handleSubmit}
                    >
                      {({ errors, touched }) => (
                        <Form>
                          <InputComponent
                            label="Enter OTP"
                            id="otp"
                            type="text"
                            className="mb-5 w-full"
                            value={otpFormik.values.otp}
                            onChange={otpFormik.handleChange}
                            error={otpFormik.errors.otp || errorMessage}
                          />

                          <button
                            type="submit"
                            onClick={otpFormik.handleSubmit}
                            className="min-w-[131px] w-full text-base font-medium rounded-lg py-2 px-5  bg-[#2E37A4] hover:bg-[#1A238F] text-white"
                          >
                            Verify OTP
                          </button>
                        </Form>
                      )}
                    </Formik>
                  </>
                )}
              </div>
            </div>
          </div>

          {step === 3 && (
            <div className="xl:w-11/12 px-5 py-5">
              <div className="bg-white  px-8 md:px-10 xl:px-14 py-12  rounded-2xl">
                <div className="mb-8">
                  <h3 className="mb-1 text-xl font-bold">Sign Up</h3>
                  <p className="text-gray-600">
                    And lets get started with your free trial
                  </p>
                </div>

                <Formik
                  initialValues={registrationFormik.initialValues}
                  validationSchema={registrationFormik.validationSchema}
                  onSubmit={registrationFormik.handleSubmit}
                >
                  {({ errors, touched }) => (
                    <Form
                      className=" flex flex-wrap -mx-3"
                      style={{ marginBottom: "20px" }}
                    >
                      <InputComponent
                        label="Email"
                        id="email"
                        value={registrationFormik.values.email}
                        onChange={registrationFormik.handleChange}
                        type="email"
                        className="mb-5 w-6/12 px-3"
                        error={registrationFormik?.errors?.email}
                      />

                      <div className="mb-5 w-6/12 px-3 relative">
                      <InputComponent
                        label="Password"
                        id="password"
                        value={registrationFormik.values.password}
                        onChange={registrationFormik.handleChange}
                        type={showPassword ? "text" : "password"} // Conditionally set the type based on state
                        className="w-full"
                        error={registrationFormik?.errors?.password}
                      />
                      <VisibilityIcon
                        type="button"
                        onClick={togglePasswordVisibility}
                        className="absolute top-9 right-7"
                      />

                      </div>

                      <div className="mb-5 w-6/12 px-3 relative">
                      <InputComponent
                        label="Confirm Password"
                        id="confirmPassword"
                        value={registrationFormik.values.confirmPassword}
                        onChange={registrationFormik.handleChange}
                        type={showConfirmPassword ? "text" : "password"} // Conditionally set the type based on state
                        className="w-full"
                        error={registrationFormik?.errors?.confirmPassword}
                      />
                      <VisibilityIcon
                        type="button"
                        onClick={toggleConfirmPasswordVisibility}
                        className="absolute top-9 right-7"

                      />
                      </div>

                      <div className="mb-5 w-6/12 px-3">
                        <label
                          for="role"
                          class="mb-1 text-gray-800 bg-white font-semibold text-[14px] block"
                        >
                          Role
                        </label>
                        <CustomSelect
                          id="role"
                          value={role}
                          isSearchable={false}
                          isClearable={false}
                          isDisabled={false}
                          className={" w-full form_select"}
                          onChange={(e) => {
                            setRole(e.value);
                          }}
                          options={Role}
                        />
                      </div>

                      <InputComponent
                        label="First Name"
                        id="firstName"
                        value={registrationFormik.values.firstName}
                        onChange={registrationFormik.handleChange}
                        type="text"
                        className="mb-5 w-6/12 px-3"
                        error={registrationFormik?.errors?.firstName}
                      />
                      <InputComponent
                        label="Last Name"
                        id="lastName"
                        value={registrationFormik.values.lastName}
                        onChange={registrationFormik.handleChange}
                        type="text"
                        className="mb-5 w-6/12 px-3"
                        error={registrationFormik?.errors?.lastName}
                      />
                      <InputComponent
                        label="Clinic Name"
                        id="clinicName"
                        value={registrationFormik.values.clinicName}
                        onChange={registrationFormik.handleChange}
                        type="text"
                        className="mb-5 w-6/12 px-3"
                        error={registrationFormik?.errors?.clinicName}
                      />
                      {role === "doctor" && (
                        <>
                          <InputComponent
                            label="Experience (Years)"
                            id="experience"
                            value={registrationFormik.values.experience}
                            onChange={registrationFormik.handleChange}
                            type="number"
                            className="mb-5 w-6/12 px-3"
                            error={registrationFormik?.errors?.experience}
                          />
                          {role === "doctor" && (
                            <InputComponent
                              label="Specialty"
                              id="speciality"
                              value={registrationFormik.values.speciality}
                              onChange={registrationFormik.handleChange}
                              type="text"
                              className="mb-5 w-6/12 px-3"
                              error={registrationFormik?.errors?.speciality}
                            />
                          )}
                          <InputComponent
                            label="Qualification"
                            id="qualification"
                            value={registrationFormik.values.qualification}
                            onChange={registrationFormik.handleChange}
                            type="text"
                            className="mb-5 w-6/12 px-3"
                            error={registrationFormik?.errors?.qualification}
                          />
                          <InputComponent
                            label="Consultation Fee"
                            id="consultationFee"
                            value={registrationFormik.values.consultationFee}
                            onChange={registrationFormik.handleChange}
                            type="text"
                            className="mb-5 w-6/12 px-3"
                            error={registrationFormik?.errors?.consultationFee}
                          />

                          {/* Working Hours inputs */}
                          {/* <div className="mb-5 w-6/12 px-3">
                            <label className="block mb-1 text-sm font-medium text-gray-700">
                              Working Hours:
                            </label>
                            <div className=" grid grid-cols-[1fr_25px_1fr] gap-4">
                              <div>
                                <input
                                  type="time"
                                  value={workingHours.start}
                                  onChange={(e) =>
                                    setWorkingHours({
                                      ...workingHours,
                                      start: e.target.value,
                                    })
                                  }
                                  className="border rounded px-2 py-1 text-gray-700 w-full"
                                  aria-label="Start Time"
                                />

                                {errors["working_hours.start"] && (
                                  <div className="text-red-500 text-sm">
                                    {errors["working_hours.start"]}
                                  </div>
                                )}
                              </div>
                              <span className="text-sm font-medium text-gray-700">
                                to
                              </span>
                              <div>
                                <input
                                  type="time"
                                  value={workingHours.end}
                                  onChange={(e) =>
                                    setWorkingHours({
                                      ...workingHours,
                                      end: e.target.value,
                                    })
                                  }
                                  className="border rounded px-2 py-1 text-gray-700  w-full"
                                  aria-label="End Time"
                                />
                                {errors["working_hours.end"] && (
                                  <span className="text-red-500 text-sm ">
                                    {errors["working_hours.end"]}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div> */}

                          <div className="mb-5 w-full px-3">
                            <label className="block mb-1 text-sm font-medium text-gray-700">
                              Working Days:
                            </label>
                            <div className="flex flex-wrap gap-2">
                              {Object.keys(initialWorkingDays).map((day) => (
                                <label
                                  key={day}
                                  className="inline-flex items-center"
                                >
                                  <input
                                    type="checkbox"
                                    checked={workingDays[day]}
                                    onChange={() =>
                                      setWorkingDays({
                                        ...workingDays,
                                        [day]: !workingDays[day],
                                      })
                                    }
                                    className="form-checkbox h-5 w-5 text-blue-600"
                                  />
                                  <span className="ml-2 text-sm text-blue-700 capitalize">
                                    {day}
                                  </span>
                                </label>
                              ))}
                            </div>

                            {errors.working_days && (
                              <div className=" text-red-500 text-sm">
                                {errors.working_days}
                              </div>
                            )}
                          </div>

                          {/* Working Hours inputs */}
                          {Object.values(workingDays).includes(true) && (
                            <div className="w-full px-3">
                              <label className="block mb-1 text-sm font-medium text-gray-700">
                                Working Hours:
                              </label>
                              <div className="flex flex-wrap -mx-3">
                                {Object.keys(workingHours)?.map((day) => (
                                  <div
                                    key={day}
                                    className={
                                      workingDays[day]
                                        ? " px-3 w-1/2"
                                        : "hidden"
                                    }
                                  >
                                    <div className="p-4 bg-blue-50 rounded-md w-full mb-3">
                                      <div className="w-[40px] flex items-center border-b border-blue-500  ">
                                        <label className="block text-gray-700 mb-1 text-left capitalize">
                                          {day}
                                        </label>
                                      </div>

                                      {workingHours[day]?.map(
                                        (timeSlot, index) => (
                                          <div
                                            key={index}
                                            className="flex gap-2 my-2"
                                          >
                                            <label className=" inline-flex gap-x-3 min-w-24">
                                              <input
                                                type="checkbox"
                                                checked={timeSlot.enabled}
                                                onChange={(e) =>
                                                  handleWorkingHoursChange(
                                                    day,
                                                    index,
                                                    "enabled",
                                                    e.target.checked
                                                  )
                                                }
                                              />
                                              {index == 0 ? (
                                                <span className="  self-center">
                                                  Morning
                                                </span>
                                              ) : (
                                                <span className="  self-center">
                                                  Evening
                                                </span>
                                              )}
                                            </label>
                                            <input
                                              type="time"
                                              value={timeSlot.start}
                                              onChange={(e) =>
                                                handleWorkingHoursChange(
                                                  day,
                                                  index,
                                                  "start",
                                                  e.target.value
                                                )
                                              }
                                              className="input-control  w-full"
                                              disabled={!timeSlot.enabled}
                                            />
                                            <p className=" flex items-center">
                                              -
                                            </p>
                                            <input
                                              type="time"
                                              value={timeSlot.end}
                                              onChange={(e) =>
                                                handleWorkingHoursChange(
                                                  day,
                                                  index,
                                                  "end",
                                                  e.target.value
                                                )
                                              }
                                              className="input-control  w-full"
                                              disabled={!timeSlot.enabled}
                                            />
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                        </>
                      )}

                      <div className="px-3 w-full">
                        <button
                          type="submit"
                          onClick={registrationFormik.handleSubmit}
                          className="min-w-[131px] w-full text-base font-medium rounded-lg py-2 px-5  bg-[#2E37A4] hover:bg-[#1A238F] text-white"
                          disabled={!isOtpVerified}
                        >
                          Register
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          )}
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Registration;